import { PROJECTS_EVENT } from 'subscriptions/events/events.enum';
import { subscriptionsFabric } from 'subscriptions/subscriptions.fabric';
import currentWorklogActions from 'store/currentWorklog/actions';
import projectTypesActions from 'store/projectTypes/projectTypesActions';
import { lcCreatedHandler, lcUpdatedHandler, applyLcDeletedToCaches } from 'store/laborClassifications';
import { stripLcFromProject } from 'helpers/laborClassification';


const handlers = {
  [PROJECTS_EVENT.updated]: (store) => (data) => {
    if (!data._id) return;

    const currentWorklog = store.getState().currentWorklog.worklogSheet?.sheet;
    if (currentWorklog?._id && currentWorklog?.projectId === data._id && !currentWorklog.published) {
      store.dispatch(
        currentWorklogActions.patchWorklogSheet({ project: { ...currentWorklog.project, ...data } })
      );
    }

    const organizationLocation = store.getState().personalProfile?.organizationLocation;
    if (organizationLocation) {
      if (!data?.assignedToLocations?.includes(organizationLocation?._id)) {
        store.dispatch(projectTypesActions.deleteProject(data?._id))
      }
    }
  },

  [PROJECTS_EVENT.lcCreated]: lcCreatedHandler,
  [PROJECTS_EVENT.lcUpdated]: lcUpdatedHandler,
  [PROJECTS_EVENT.lcDeleted]: (store) => (data) => {
    applyLcDeletedToCaches(store, data);
    const lcId = data?._id;
    if (!lcId) return;

    const sheet = store.getState().currentWorklog.worklogSheet?.sheet;
    const project = stripLcFromProject(sheet?.project, lcId);
    if (sheet?.project && project !== sheet.project) {
      store.dispatch(currentWorklogActions.patchWorklogSheet({ project }));
    }
  },
};

export const currentWorklogProjectsSubscriptionMiddleware = subscriptionsFabric(
  currentWorklogActions,
  PROJECTS_EVENT,
  handlers
);
